//Assets
import D from "img/d-icon.svg";
import robotIcon from "img/robot-icon.svg";
import ordersIcon from "img/orders-icon.svg";
import itemValidity from "img/item-validity.svg";
import { ReportDashboardIndicator } from "models/ReportDashboardIndicator";

export const simplifiedAutomaticAnswer: ReportDashboardIndicator = {
  title: "RA",
  value: "(SIMPLIFICADO)",
  image: robotIcon,
  imageVisibility: true,
};

export const newDate: ReportDashboardIndicator = {
  title: "Próximos do venc.",
  image: itemValidity,
  imageVisibility: true,
};

export const automatic: ReportDashboardIndicator = {
  title: "De/ParasAuto.",
  image: D,
  imageVisibility: true,
};

export const orders: ReportDashboardIndicator = {
  title: "Pedidos",
  image: ordersIcon,
  imageVisibility: true,
};